async function fetchNextPage(url) {
  try {
    const response = await fetch(url);
    return await response.text();
  } catch (error) {
    console.error("Error fetching page:", error);
  }
}

let nextPageSearchUrl = false;

function setProgressBar(totalProductCount) {
  const productCountElement = document.querySelector('.load_more_product_count');
  const productsContainer = document.querySelector('.grid.product-grid');
  const progressBar = document.querySelector('.load-more-progressbar > div');
  productCountElement.textContent = productsContainer.childElementCount;
  progressBar.style.width = `${(productsContainer.childElementCount / totalProductCount) * 100}%`;
}

async function loadMoreProducts(nextUrl, totalProductCount) {
  const productsContainer = document.querySelector('.grid.product-grid');
  const loadMoreButton = document.querySelector('.load-more_btn');
  
  try {
    loadMoreButton.style.display = 'none';
    const nextPageHTML = await fetchNextPage(nextPageSearchUrl || nextUrl);
    const doc = new DOMParser().parseFromString(nextPageHTML, 'text/html');
    doc.querySelectorAll('.grid.product-grid > li').forEach(product => productsContainer.appendChild(product.cloneNode(true)));
    nextPageSearchUrl = getNextPageHref(doc.querySelector('.pagination__list'));
    loadMoreButton.style.display = nextPageSearchUrl ? 'inline-flex' : 'none';
    setProgressBar(totalProductCount);
  } catch (error) {
    console.error("Error loading more products:", error);
  }
}

function getNextPageHref(paginationList) {
  const currentItem = paginationList.querySelector('.pagination__item--current');
  if (currentItem) {
    const nextItem = currentItem.parentNode.nextElementSibling;
    if (nextItem) {
      const link = nextItem.querySelector('a');
      if (link) {
        return link.href;
      }
    }
  }
  return null;
}